import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'


export default function Users() {
    const { t } = useTranslation()
    const {client} = useAuth()

    const users = [
        {
            name: "Manolo",
            email: "comercial@reagracordoba.es",
            rol: "Admin",
            phone: "66042109",
            active: true,
        },
        {
            name: "Ana",
            email: "ana@reagracordoba.es",
            rol: "Admin",
            phone: "623941635",
            active: true,
        },
        {
            name: "Pablo",
            email: "pablo@reagracordoba.es",
            rol: "Oficina",
            phone: "658434619",
            active: true,
        },
        {
            name: "Francisco",
            email: "francisco@reagracordoba.es",
            rol: "Oficina",
            phone: "615289326",
            active: false,
        },
        {
            name: "María",
            email: "maria@reagracordoba.es",
            rol: "Oficina",
            phone: "666282882",
            active: true,
        },
    ]
    const columnsUsers = [
        {
            name: t('users.name'),
            cell: users =>
                <div className='cursor'>
                    {users.name}
                </div>,
            selector: (users) => users.name,
            sortable: true,
        },{
            name: t('users.email'),
            cell: users =>
                <div className='cursor'>
                    {users.email}
                </div>,
            selector: (users) => users.email,
            sortable: true,
        },{
            name: t('users.rol'),
            width: '150px',
            cell: users =>
                <div className='cursor'>
                    {users.rol}
                </div>,
            selector: (users) => users.rol,
            sortable: true,
        },{
            name: t('users.phone'),
            width: '150px',
            cell: users =>
                <div className='cursor' >
                    {users.phone}
                </div>,
            selector: (users) => users.phone,
            sortable: true,
        },{
            name: t('users.active'),
            width: '80px',
            cell: users =>
                <div>
                    {users.active
                        ?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (users) => users.active,
            sortable: true,
        },{
            name: '',
            width: '100px',
            center: 'center',
            cell: users =>
                <>
                    <div className='cursor me-3'>
                        <i className='fas fa-pencil'></i>
                    </div>
                </>,
            sortable: false,
        }
    ]
    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col xs={12} className='text-center'>
                    <h1>
                        {t('admin.dashboard.users')}
                    </h1>
                </Col>
                <Col xs={6}></Col>
                <Col xs={6} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor">
                        {t('users.createuser')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <CustomDataTable
                        columns={columnsUsers}
                        data={users}
                        exportable={false}
                        printable={false}
                    />
                </Col>
            </Row>
        </Container>
    )
}